import { CssBaseline, ThemeProvider } from '@mui/material';
import type { ReactNode } from 'react';
import { otaTheme } from '../theme';

interface OtaThemeProviderProps {
  children: ReactNode;
}

/**
 * Wraps an app with the centralized OTA MUI theme + global CSS reset.
 * All three frontends (PropertyEnlist, OTA_internal, OTA public) wrap their
 * root `<App />` in this provider.
 */
export function OtaThemeProvider({ children }: OtaThemeProviderProps) {
  return (
    <ThemeProvider theme={otaTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
